
      <div class="cursor" [style.left.px]="position?.x" [style.top.px]="position?.y"></div>
    